import { render } from "./GlobalComponents.vue?vue&type=template&id=81e6d0f2"
import script from "./GlobalComponents.vue?vue&type=script&lang=js"
export * from "./GlobalComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__